import { render, staticRenderFns } from "./Leftbar.vue?vue&type=template&id=4ad21952&"
import script from "./Leftbar.vue?vue&type=script&lang=js&"
export * from "./Leftbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ad21952')) {
      api.createRecord('4ad21952', component.options)
    } else {
      api.reload('4ad21952', component.options)
    }
    module.hot.accept("./Leftbar.vue?vue&type=template&id=4ad21952&", function () {
      api.rerender('4ad21952', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Leftbar.vue"
export default component.exports